<script lang="ts">
  import PrimaryLeft from './assets/primary-left.webp';
  import PrimaryRight from './assets/primary-right.webp';
</script>

<div class="pointer-events-none absolute -left-[130px] top-[51px] hidden w-[400px] xl:block">
  <img role="presentation" src={PrimaryLeft} alt="" />
</div>

<div class="pointer-events-none absolute -right-[170px] top-[51px] hidden w-[400px] xl:block">
  <img role="presentation" src={PrimaryRight} alt="" />
</div>
